import { useRef } from 'react';
import { useAppSelector } from '../../useReduxToolkit';
import { type CallParticipant } from '../../useCallParticipants';
import { getJoinedParticipantsIds } from '../../../features/apolloSession/apolloSession.selectors';
import { getIsInGroupCall } from '../../../features/session/session.selectors';
import { GetUserAvatarForNotification } from '../../../shared/getUserAvatarForNotification';
import { toast } from '@doxyme/ui/components/foundations';
import { useIntl } from '@doxyme/locale';

export const useNotificationPatientJoined = (): ((
  participant: CallParticipant,
) => Promise<void>) => {
  const isInGroupCall = useAppSelector(getIsInGroupCall);
  const joinedParticipantsIds = useAppSelector(getJoinedParticipantsIds);
  const shownNotificationOfParticipant = useRef<Record<string, boolean>>({});
  const { formatMessage } = useIntl();

  return async (participant: CallParticipant): Promise<void> => {
    if (!isInGroupCall) {
      return;
    }

    if (shownNotificationOfParticipant.current[participant.id] !== true) {
      if (!joinedParticipantsIds.includes(participant.id)) {
        toast({
          title: formatMessage(
            { id: 'joinedCall' },
            { username: participant.username },
          ),
          icon: GetUserAvatarForNotification(participant.picture),
        });
      }

      shownNotificationOfParticipant.current[participant.id] = true;
    }
  };
};
